import type { StepperProps } from 'widgets/project-creation-stepper/ui/upload-component';
import { useServiceType } from 'widgets/project-creation-stepper/providers/service-provider';
import { AddVariable } from 'features/add-variable/ui/add-variable';
import * as m from '@paraglide/messages';
import { EnvVarsDataTable } from 'widgets/env-var-data-table';
export const VariablesComponent = ({
  next
}: StepperProps) => {
  const {
    projectSlug,
    serviceType,
    uploadType,
    setUploadType
  } = useServiceType();
  console.log(projectSlug);
  if (serviceType === 'db' || serviceType === 'marketplace') {
    next();
  }
  return <div className="flex size-full flex-col gap-8" data-sentry-component="VariablesComponent" data-sentry-source-file="varialbes-component.tsx">
      <div className="flex gap-2 w-full flex-col md:flex-row">
        <AddVariable text={m.tab_envvars_dialog_secret_btn()} isSecret slug={projectSlug} data-sentry-element="AddVariable" data-sentry-source-file="varialbes-component.tsx" />
        <AddVariable text={m.tab_envvars_dialog_var_btn()} slug={projectSlug} data-sentry-element="AddVariable" data-sentry-source-file="varialbes-component.tsx" />
      </div>
      <EnvVarsDataTable slug={projectSlug} withPagination={false} data-sentry-element="EnvVarsDataTable" data-sentry-source-file="varialbes-component.tsx" />
    </div>;
};